import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { Logger } from '../../../../../../../infrastructure/logging/logger';
import { ImageUtility } from '../../../../../../../utilities/ImageUtility';
import { ReferenceService } from '../../../../../../../shared/reference/reference.service';
import { SupportingDocument } from '../../models/SupportingDocumentSection.model';

interface ClaimDraftSupportingDocumentData {
  isImage: boolean;
  document: SupportingDocument;
}

@Component({
  selector: 'app-draft-supporting-document-dialog',
  templateUrl: './draft-supporting-document-dialog.component.html',
  styleUrls: ['./draft-supporting-document-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinner,
    MatIcon,
    MatDialogModule,
    FormsModule
  ]
})
export class DraftSupportingDocumentDialogComponent implements OnInit {

  loadingImage = false;
  imageSource?: any;
  description?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ClaimDraftSupportingDocumentData,
    private readonly dialogRef: MatDialogRef<DraftSupportingDocumentDialogComponent>,
    private readonly referenceService: ReferenceService,
    private readonly imageUtility: ImageUtility,
    private readonly logService: Logger
  ) { }

  ngOnInit(): void {
    this.description = this.data.document.description;
    if(this.data.isImage) {
      this.loadingImage = true;
      this.downloadImage();
    }
  }

  async downloadImage() {
    try {
      if (!this.data.document.id) {
        return;
      }

      const imageData = await this.referenceService.getFileDataById(this.data.document.id);
      if (imageData == null) {
        return;
      }

      const image = await this.imageUtility.getFileFromBlob(imageData.image);
      if (image == null) {
        return;
      }

      this.imageSource = image;
    } catch (e) {
      this.logService.handleError(e, 'An error occurred while retrieving Claim image', `Error while downloading image to display. Image File ID: ${this.data.document.id}`);
    } finally {
      this.loadingImage = false;
    }
  }

  onDeleteClick() {
    this.dialogRef.close({ id: this.data.document.id, action: 'delete' });
  }

  onSaveClick() {
    this.data.document.description = this.description;
    this.dialogRef.close({ id: this.data.document.id, action: 'description', description: this.description });
  }
}